import { render, staticRenderFns } from "./reducaoacrescimo.vue?vue&type=template&id=0eaa821b"
import script from "./reducaoacrescimo.vue?vue&type=script&lang=js"
export * from "./reducaoacrescimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports